export default [
  {
    path: '/fnf-league/games',
    name: 'fnf-league-games',
    component: () => import('@/views/fnf-league/FnfLeagueGames.vue'),
    meta: {
      pageTitle: 'Игры Лиги',
      breadcrumb: [
        { text: 'ФНФ Лига' },
        { text: 'Игры', active: true },
      ],
      resource: 'fnf-league',
      action: 'view',
    },
  },
  {
    path: '/fnf-league/games/:id',
    name: 'fnf-league-game-view',
    component: () => import('@/views/fnf-league/FnfLeagueGameView.vue'),
    meta: {
      pageTitle: 'Игра Лиги',
      breadcrumb: [
        { text: 'ФНФ Лига' },
        { text: 'Игры', to: { name: 'fnf-league-games' } },
        { text: 'Деталка', active: true },
      ],
      resource: 'fnf-league',
      action: 'view',
    },
  },
  {
    path: '/fnf-league/schedule',
    name: 'fnf-league-schedule',
    component: () => import('@/views/fnf-league/FnfLeagueSchedule.vue'),
    meta: {
      pageTitle: 'Расписание',
      breadcrumb: [
        { text: 'ФНФ Лига' },
        { text: 'Расписание', active: true },
      ],
      resource: 'fnf-league',
      action: 'view',
    },
  },
  {
    path: '/fnf-league/tables',
    name: 'fnf-league-tables',
    component: () => import('@/views/fnf-league/FnfLeagueTables.vue'),
    meta: {
      pageTitle: 'Таблицы Лиги',
      breadcrumb: [
        { text: 'ФНФ Лига' },
        { text: 'Таблицы', active: true },
      ],
      resource: 'fnf-league',
      action: 'view',
    },
  },
]
